module.exports = __webpack_public_path__ + "static/media/3.eed7e369.jpg";